import * as React from "react";

import api from "kw/api";

export function useAnzsicCodes(year, initialCodes) {
  const [data, setData] = React.useState(initialCodes);
  const [loading, setLoading] = React.useState(!data);
  React.useEffect(() => {
    if (!data) {
      api
        .query({
          allAnzsicCodeDivisions: [
            {
              year: year,
            },
            {
              id: true,
              label: true,
              subdivisions: {
                id: true,
                label: true,
                groups: {
                  id: true,
                  label: true,
                  classes: {
                    id: true,
                    label: true,
                  },
                },
              },
            },
          ],
        })
        .then((r) => setData(r.allAnzsicCodeDivisions))
        .finally(() => setLoading(false));
    }
  }, []);
  return [data, { loading }];
}
